import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import { UndergroundIconWrapper } from '../../../components/UndergroundIconWrapper';
import { useOfferContext } from '../../../context';
import { ELocationTypeId, IAddress } from '../../../types/offer';

export function UndergroundIconContainer() {
  const { offer, underground } = useOfferContext();

  const id = React.useMemo(() => {
    const { id } =
      (offer.geo && offer.geo.address.find(item => item.locationTypeId === ELocationTypeId.City)) || ({} as IAddress);

    return id;
  }, [offer.geo]);

  const color = React.useMemo(() => (underground && `#${underground.lineColor}`) || undefined, [underground]);

  const icon = React.useMemo(() => {
    switch (id) {
      case 2:
        return <IconMetroSpb16 color="current_color" />;
      case 4743:
        return <IconMetroEkb16 color="current_color" />;
      case 4777:
        return <IconMetroKzn16 color="current_color" />;
      case 4897:
        return <IconMetroNovosib16 color="current_color" />;
      case 4966:
        return <IconMetroSam16 color="current_color" />;
      case 4885:
        return <IconMetroNN16 color="current_color" />;
      default:
        return <IconMetroMsk16 color="current_color" />;
    }
  }, [id]);

  if (!underground) {
    return null;
  }

  return <UndergroundIconWrapper color={color}>{icon}</UndergroundIconWrapper>;
}
